import React, { useState, useEffect } from 'react';
import { TerminalConfigsVService } from '../../services/V2/padre';

export function Terminal({ operatorId, setTerminalId, districtId }) {
    const [terminals, setTerminals] = useState<any[]>([]);
    
    useEffect(() => {
        TerminalConfigsVService.terminalConfigsVGetAll(operatorId, {
                pageNumber:  1,
                orderBy:"Id",
                orderByDesc: true,
                filters: [{
                    property: "OperatorId",
                    value: operatorId
                }]
            })
            .then(t => setTerminals(t.items ?? []))
            .catch(err => console.log("couldn't find terminals"));
    }, [operatorId])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = event => {
        let value = event.target.value === "" ? null : event.target.value;
        let terminal = terminals.find(x => x.id === value)
        setTerminalId(terminal.id)
    }

    return (
        <>
            <div style={{display:"flex", justifyContent:"flex-end"}}>
                <label className='uvp-label' style={{marginTop: "20px"}}>
                    <b>Terminal</b><span>&nbsp;:&nbsp;</span>
                    <select
                        className='uvp-select'
                        defaultValue={""}
                        onChange={handleChange}
                        style={{width: "250px", height: "22px", padding: "1px 2px", border: "2px inset lightdark"}}
                        name="terminal">
                        <option value=""></option>
                        {terminals.map((t, i) => {
                            return <option key={`${i}-term`} value={t.id}>
                                    {t.nickname}
                                </option>
                        })}
                    </select>
                </label>
            </div>
        </>
    );
}